import UpdateAmendmentLienCost from "../Update";

const ViewAmendmentLienCost = (props) => {
  return <UpdateAmendmentLienCost {...props} viewMode={true} />;
};

export default ViewAmendmentLienCost;
